import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  toastContainer: {
    position: "fixed",
    bottom: "208px",
    left: 0,
    width: "100%",
    backgroundColor: "#929292c7",
    textAlign: "center",
    padding: "10px",
    color: "white",
  },
  toastContent: {},
}));

export default ({ children, onClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.toastContainer}>
      <div className={classes.toastContent} onClick={onClick}>
        {children}
      </div>
    </div>
  );
};
